<template>
	<div class="indexView">
		<el-container>
			<el-main>
				<HeaderRow selUrl=""></HeaderRow>
				<div class="breadcrumb">
					<div class="backItem" @click="()=>$router.back()"><i class="el-icon-arrow-left">返回</i></div>
					<el-breadcrumb separator="/">
						<el-breadcrumb-item to="/">首页</el-breadcrumb-item>
						<el-breadcrumb-item to="/myOrder">我的订单</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
				<div class="content">
					<div class="leftMenu">
						<p class="sel">
							<i class="el-icon-s-unfold"></i> 我的订单
						</p>
						<p @click="toMyPage('myCourse')">
							<i class="el-icon-menu"></i> 我的课程
						</p>
						<p @click="toMyPage('myCollect')">
							<i class="el-icon-star-on"></i> 我的收藏
						</p>
						<p @click="toMyPage('myPartner')">
							<i class="el-icon-s-custom"></i> 我的团队
						</p>
					</div>
					<div class="rightList">
						<div class="status">
							<div v-for="(status, index) in statusList" :class="index===selIndex?'status statusSel':'status'"
								@click="onStatusChange(index)">
								<span>{{status.name}}</span>
								<span />
							</div>
						</div>
						<div class="list" v-if="orderList&&orderList.length">
							<div class="listItem" v-for="item in orderList" :key="item.out_trade_no">
								<div class="order">
									<span>订单号：</span>
									<span>{{item.out_trade_no}}</span>
									<span>{{['未支付','已完成','售后中','已售后'][item.status]}}</span>
								</div>
								<div class="info">
									<div v-for="e in item.detail" :key="e.course_id">
										<div class="pro" v-if="e&&e.course">
											<img :src="e.course.thumb_image"></img>
											<div class="right">
												<span>{{e.course.title}}</span>
												<span>￥{{Price(e.price,2)}}</span>
											</div>
										</div>
										<div class="pro" v-else-if="e&&e.special">
											<img :src="e.special.image"></img>
											<div class="right">
												<span>{{e.special.name}}</span>
												<span>￥{{Price(e.price,2)}}</span>
											</div>
										</div>
										<div class="pro" v-else>
											<img src="@/assets/placeholder.jpg"></img>
											<div class="right">
												<span>订单信息不完整</span>
												<span>￥**</span>
											</div>
										</div>
									</div>
									<div class="youhui" v-if="item.user_coupon_id">
										<p>
											<span>优惠券抵扣</span>
											<span>￥{{ Price((item.total_amount * 100 - item.pay_amount * 100) / 100, 2) }}</span>
										</p>
										<p>
											<span>实付</span>
											<span>￥{{ Price(item.pay_amount, 2) }}</span>
										</p>
									</div>
									<div class="youhui" v-else-if="item.score">
										<p>
											<span>乐币抵扣</span>
											<span>￥{{ Price(item.score, 2) }}</span>
										</p>
										<p>
											<span>实付</span>
											<span>￥{{ Price(item.pay_amount, 2) }}</span>
										</p>
									</div>
									<div class="youhui" v-else>
										<p>
											<span>实付</span>
											<span>￥{{ Price(item.pay_amount, 2) }}</span>
										</p>
									</div>
									<div class="action">
										<span>下单时间：{{item.created_at}}</span>
										<button v-if="item.status==0" size="default" type="default" class="payBtn" hover-class="btnHover"
											@click="gotoPay(item)">立即支付</button>
									</div>
								</div>
							</div>
						</div>
						<div v-else class="noData">
							<img src="@/assets/empty.jpg"></img>
							<span>无数据</span>
						</div>
					</div>
				</div>
				<FooterRow></FooterRow>
			</el-main>
		</el-container>
		<CashierDialog ref="cashierRef" />
	</div>
</template>

<script>
	import indexjs from "./index.js";
	import {
		copy
	} from "clipboard";
	import HeaderRow from "@/components/headerRow.vue";
	import FooterRow from "@/components/footerRow.vue";
	import CashierDialog from "@/components/cashierDialog.vue";

	export default {
		methods: {
			copy,
		},
		computed: {
			Price() {
				return (price, digit) => parseFloat(price).toFixed(digit || 0);
			},
		},
		...indexjs,
		components: {
			HeaderRow,
			FooterRow,
			CashierDialog
		},

	};
</script>

<style lang="scss" scoped>
	@import "./index.scss";
</style>